import React from "react";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const UniversalTable = ({ headers, data, renderFooterElement }) => {
  return (
    <div className="cashInFlowTable">
      <table className="custom-table">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index} className="table-header">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="table-row">
              <td className="table-cell">
                {row?.receiptId}
                <br />
                <span id="time">{row?.time}</span>
              </td>
              <td className="table-cell">{row?.incomeType}</td>
              <td className="table-cell">Check Out</td>
              <td className="table-cell">
                ₹{row.amount} <br /> <span id="paymentMode">{row?.mode}</span>
              </td>
              <td className="table-cell">
                {row?.paidBy} <br />
                ph: <span>{row?.phoneNumber}</span>
              </td>
              <td className="table-cell">
                {row?.paidBy} <br />
                ph: <span>{row?.phoneNumber}</span>
              </td>
              <td className="table-cell">{row.confirmedby}</td>
              <td className="table-cell">
                <button className="custom-button">
                  Receipt
                  <BsBoxArrowRight />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {renderFooterElement}
    </div>
  );
};

export default UniversalTable;
